import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Loader from 'components/loaders/Loader/Loader'

import s from './ContentLoader.scss'


const ContentLoader = ({ className, fullHeight }) => (
  <div className={cx(s.loaderContainer, className, { [s.fullHeight]: fullHeight })}>
    <Loader />
  </div>
)

ContentLoader.propTypes = {
  className: PropTypes.string,
  fullHeight: PropTypes.bool,
}


export default ContentLoader
